var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaptableIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 338.69 324.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.37,125.16A47.66,47.66,0,0,1,167.28,103a5,5,0,0,0,8,1.28L228.2,51.35,200.39,23.54a8.42,8.42,0,0,0-11.77,0L175.06,37.09a99.06,99.06,0,0,0-22.81-9.28V8.55A8.45,8.45,0,0,0,143.7,0H106.61a8.55,8.55,0,0,0-8.55,8.55V27.8a98.78,98.78,0,0,0-22.82,9.28L61.69,23.52a8.42,8.42,0,0,0-11.77,0l-26,26a8.4,8.4,0,0,0,0,11.77L37.44,74.88a99.06,99.06,0,0,0-9.28,22.81H8.55A8.45,8.45,0,0,0,0,106.24V143a8.55,8.55,0,0,0,8.55,8.56H27.8a98.88,98.88,0,0,0,9.28,22.81L23.52,187.89a8.1,8.1,0,0,0,0,11.77l27.82,27.82,52.75-52.75a5,5,0,0,0-1.33-8,46.08,46.08,0,0,1-25.39-41.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 108.98,
    y: 145.27,
    width: 179.7,
    height: 77.37,
    rx: 10,
    transform: "translate(-71.84 194.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.17,86.28,297,47.77a11.41,11.41,0,0,0-16.41,0L262.72,65.66a10,10,0,0,0,0,14.14l40.77,40.76a10,10,0,0,0,14.14,0l17.89-17.89c4.29-4.62,4.29-12.11-.35-16.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.46,254.94a14.89,14.89,0,0,0-3.21,5.71L58.83,310.21a11.78,11.78,0,0,0,13.9,13.9l49.56-11.41a10.34,10.34,0,0,0,5.71-3.2l7.19-7.2a10,10,0,0,0,0-14.14l-40.4-40.41a10,10,0,0,0-14.14,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptableIc);
export default __webpack_public_path__ + "static/media/adaptable-ic.d24d70bb07ac53f43b8e5160dda477ca.svg";
export { ForwardRef as ReactComponent };